
export const LINKS = {
  calendly: "https://calendly.com/pkr-recruit-and-hire/consultation-pkrhires",
  careers: "https://loxo.co/panna-knows",
  pkrhub: "https://pkrhub.ai",
};

export const SOCIALS = [
  { id: "linkedin", label: "LinkedIn", href: "https://www.linkedin.com/company/pkrhires" },
  { id: "instagram", label: "Instagram", href: "https://www.instagram.com/pkrecruiting/" },
  { id: "facebook", label: "Facebook", href: "https://www.facebook.com/Panna-Knows-1912435738867965/" },
];

export const IMAGES = {
  logo: "/pkr-logo.png",
  hero: "/images/hero-team.jpg",
};

export const SERVICE_LINKS = [
  { id: "rpo", label: "RPO", href: "/#rpo" },
  { id: "staffing", label: "Staffing", href: "/#staffing" },
  { id: "retained", label: "Retained Search", href: "/#retained" },
];

export const NAV_LINKS = [
  { id: "services", label: "Services", href: "/#services", children: SERVICE_LINKS },
  { id: "coaching", label: "Coaching", href: "/coaching" },
  { id: "client-stories", label: "Client Stories", href: "/client-stories" },
  { id: "careers", label: "Careers", href: LINKS.careers, external: true },
];

export const MOBILE_EXTRA_LINKS = [{ id: "book", label: "The Book", href: "/coaching#book" }];

export const STATS = [
  { value: 90, suffix: "%+", label: "hiring manager satisfaction rate" },
  { value: 94, suffix: "%", label: "candidate satisfaction rating" },
  { value: 25, suffix: "%", label: "faster time to fill than the national average" },
  { value: 98, suffix: "%", label: "of clients return for additional hiring cycles" },
  { value: 100, suffix: "+", label: "roles filled in under 90 days for hyper-growth clients" },
  { value: 89, suffix: "%", label: "of PKR hires are still employed after 12 months" },
];

export const SERVICES = [
  {
    id: "rpo",
    title: "Recruitment Process Outsourcing (RPO)",
    intro: "Your recruiting team: embedded, accountable, and built to scale with you.",
    points: [
      {
        title: "Scale with you.",
        body: "Ideal for high-growth companies with inconsistent or consistent recruiting needs, with or without a dedicated internal team. We act as your recruitment team on a part-time or full-time basis.",
      },
      {
        title: "Support your team.",
        body: "We manage sourcing efforts, applicant flow, social recruitment, candidate management, tools, and client relationships, ensuring a collaborative, best-in-class experience for candidates and clients.",
      },
      {
        title: "Strengthen your process.",
        body: "Added structure and support for recruiting teams facing turnover, bandwidth issues, growth, or ongoing hiring challenges. We bring the tools and the process to help you attract the best talent.",
      },
    ],
  },
  {
    id: "staffing",
    title: "Staffing",
    intro: "Reliable W2 and 1099 hourly talent without the overhead of full-time resources.",
    points: [
      {
        title: "Flex with your needs.",
        body: "Perfect for companies or teams with unpredictable hiring cycles, project work, or temporary needs. We provide reliable W2/1099 hourly staffing without the overhead of full-time resources.",
      },
      {
        title: "Plug into your process.",
        body: "Need extra hands without extra hassle? We handle the sourcing, compliance, insurance, onboarding, and back office so you can focus on results, not red tape.",
      },
      {
        title: "Keep momentum going.",
        body: "For companies facing internal transfers, turnover, or stalled hiring efforts, we bring in trusted talent quickly, helping stabilize your team while you rebuild or restructure.",
      },
    ],
  },
  {
    id: "retained",
    title: "Retained Search",
    intro: "A dedicated, high-touch search for the one-off roles that matter most.",
    points: [
      {
        title: "Fill the critical one-offs.",
        body: "Perfect for a single leadership, executive, or hard-to-fill specialist role. When one hire will shape your business, you get our full attention, not a spot in someone's queue.",
      },
      {
        title: "Go deep, not wide.",
        body: "We map the market, approach passive talent directly, and vet every candidate against your culture and goals. You see a short, qualified slate, not a pile of résumés.",
      },
      {
        title: "Partner through the offer.",
        body: "From kickoff to signed offer, we manage scheduling, feedback, references, compensation conversations, and closing, so the search stays on track and the candidate says yes.",
      },
    ],
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Lisa Sordilla",
    title: "Chief People Officer",
    photo: "/images/cdn/f18e51ebde.png",
    quote:
      "As a past and current client of PKR, I am very impressed with the level of excellence that Kelly provides and requires of her team. PKR has greatly improved our candidate pipeline and significantly reduced our time to hire. Kelly and her team are a fantastic talent partner that is truly invested in the success of our business.",
  },
  {
    id: 2,
    name: "Peggy Crane",
    title: "Manager, Talent Acquisition Systems and Data Insights",
    photo: "/images/cdn/4ea80fb58c.png",
    quote:
      "I had the unique pleasure of working for Kelly as an employee and working with her as a client in need of recruiting services. Leaders like Kelly are rare. She is a constant force of compassion and passion for her team and clients.",
  },
  {
    id: 3,
    name: "Kevin Sheetz",
    title: "Chief Executive Officer",
    photo: "/images/cdn/a64eaa1910.png",
    quote:
      "I have now worked with Kelly and her team at PKR for several years. They have outstanding communication skills and really understand the key skill sets and attributes that you need in the perfect candidate. PKR actively pursues the hard work of finding the best people by continuously refining their approach to meet our needs, until the best candidate is hired. I've recommended PKR to others in the past and I continue to highly recommend Kelly and her team to anyone looking for an efficient and effective professional recruiting firm to fill your open positions.",
  },
  {
    id: 4,
    name: "Marquand Brown",
    title: "Chief People Officer",
    photo: "/images/cdn/abe9592aa2.png",
    quote:
      "I have partnered with Kelly and her team at PKR on several different engagements across two completely different industries and three different companies, and I could not be more pleased! Kelly and her team really spend time digging in to learn about your company culture. They then use that information, coupled with the skills and experiences required, to bring in the best talent to complement our team and company. In my prior role, Kelly and her team were instrumental in helping us find sales talent across several states throughout the US. In my current role, we are seeking the right medical imaging and nursing talent during an extremely challenging time in healthcare. Without a doubt, I knew PKR was the right company to help us find the right talent!",
  },
  {
    id: 5,
    name: "Jeremy Schmoyer",
    title: "Head of Human Resources",
    photo: "/images/cdn/bbfdfecdd1.png",
    quote:
      "Kelly and her team provided strategic and targeted recruiting that perfectly aligned with our needs. Under Kelly's leadership, the PKR team took the time to understand our strategy, culture, and role requirements, ensuring they delivered candidates who fit our organization perfectly. Kelly and her team valued transparency and maintained ongoing communication throughout the process. They became more than just trusted partners; they became extensions of our team. I highly recommend Kelly and PKR Recruiting to anyone seeking a strategic recruiting partner. They will undoubtedly exceed your expectations.",
  },
  {
    id: 6,
    name: "Courtney Brown",
    title: "Recruiting and Talent Acquisition Operations",
    category: "Coaching",
    photo: "/images/cdn/13460d6ec9.png",
    quote:
      "Kelly is a true business partner. She understands how to build relationships, and relationships take time and are ongoing. She has worked with me in a networking capacity since I have been searching for a new opportunity. She checks in frequently, expecting nothing in return. In this day and age relationships are key, and Kelly is one that has mastered the skill because of her empathy and humility.",
  },
  {
    id: 7,
    name: "Josh Dinesen",
    title: "Chief Executive Officer",
    photo: "/images/cdn/970aed7cb1.png",
    quote:
      "Kelly has been amazing to work with. You can tell Kelly really cares about finding the right fit for my company. I gave her a very challenging task for what I am looking for in building my team to help grow my company. She has some amazing people on her team who have helped me out and are great to work with as well. Kelly and her team have found some amazing talent for me that I wouldn't have been able to find on my own. You will not regret your decision to choose her.",
  },
  {
    id: 8,
    name: "George Richards",
    title: "Chief Financial Officer, Archway Programs",
    photo: "/images/cdn/561ab9aa79.png",
    quote:
      "Archway Programs has worked with PKR to fill several hard-to-fill positions on an ongoing basis and we are incredibly pleased with their services. PKR is a robust recruiting operation. They source candidates quickly, assist in setting up interviews, assist in making offers, and communicate efficiently between Archway and the candidates. They lift a huge burden of hiring off our shoulders. PKR's customer service is world class while offering a very affordable pricing plan with a high ROI.",
  },
  {
    id: 9,
    name: "Dan Kessler",
    title: "President",
    photo: "/images/cdn/7987a76939.png",
    quote:
      "Huge thanks to Kelly for spending some time with our sales team through the PKR training program. Kelly shared her vast experience in talent recruitment and what she is seeing in the current environment. It was a unique opportunity for our team to hear directly from a leader in the field and explore how to apply the lessons learned with Kelly to their day-to-day work.",
  },
];

export const PARTNERS = [
  { name: "The Main Line Chamber of Commerce", href: "https://www.mlcc.org/", logo: "/images/cdn/24555d76c9.jpeg" },
  { name: "Power Thinking Corp", href: "https://powerthinkingcorp.com/", logo: "/images/cdn/b44a089f20.jpg" },
  { name: "Greater Valley Forge Human Resources Association", href: "https://gvfhra.org/", logo: "/images/cdn/39f6b53907.jpeg" },
  { name: "SHRM", href: "https://www.shrm.org/", logo: "/images/cdn/0318d78e5b.jpeg" },
  { name: "HRPS: HR People and Strategy", href: "https://www.hrps.org/pages/default.aspx", logo: "/images/cdn/e3f1fa1a36.jpg" },
  { name: "Philly SHRM", href: "https://phillyshrm.org/", logo: "/images/cdn/0595e69d23.jpeg" },
  { name: "Philadelphia Society of People and Strategy", href: "https://www.peopleandstrategy.org/", logo: "/images/cdn/32c9280289.png" },
  { name: "JobReady2Dey", href: "https://www.jobready2dey.com/", logo: "/images/cdn/9561941429.jpg" },
  { name: "Young Entrepreneurs Academy", href: "https://www.yeaphiladelphia.org/", logo: "/images/cdn/a169f9317b.jpeg" },
];
